import { Surfaces } from "@netlify/sdk--ui-core";
import { cn } from "@netlify/ui";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type SiteDeploySurfaceProps = {
  /**
   * Content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;
};

/**
 * A container element used to render the Project Deploy page surface. This component
 * will take care of styling your component so it looks good in the ** Deploys > [your project deploy page]**
 * section of the Netlify UI.
 *
 * <!-- TODO(calebbarnes): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.SiteDeploy
 * @example
 * ```tsx
 * import { SiteDeploySurface } from "@netlify/sdk/react/components";
 *
 * <SiteDeploySurface>
 *   <div>Your surface content goes here</div>
 * </SiteDeploySurface>
 * ```
 */
export const SiteDeploySurface = ({
  className,
  children,
  ...otherProps
}: SiteDeploySurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteDeploy}-${sdk.extension.slug}`}
      /**
       * Added dark:tw-bg-black to this element so that it fits in to the
       * deploy summary row component in netlify-react-ui with the correct background color.
       */
      className={cn("dark:tw-bg-black", className)}
      {...otherProps}
    >
      {children}
    </section>
  );
};
